<template>
  <v-footer class="footer" color="#272727" padless>
    <v-row justify="center" no-gutters>
      <v-btn
        v-for="link in links"
        :key="link.title"
        color="white"
        text
        rounded
        class="my-2"
      >
        <router-link :to="link.url">{{ link.title }}</router-link>
      </v-btn>
      <v-col class="#272727py-4 text-center white--text" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>Hire Next Generation LLC, All rights reserved</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { title: 'Contact Us', url: '/contact-us' },
      { title: 'Terms of use', url: '/terms-and-conditions' },
      { title: 'Privacy policy', url: '/privacy-policy' },
    ],
  }),
};
</script>
